import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "./Tech.css";
import Techcard from "./Techcard";
import { Button } from "react-bootstrap";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";

//Passing the props to Techcard.jsx

function Tech(){
    const [expanded, setExpanded] = React.useState(false);

    function handleExpand(){
        setExpanded(!expanded);
    }

    return(
        <section id="tech">
            <Container fluid='md' className="tech-container">
                <Row>
                    <Col>
                        <div className="head">
                            <h1>Tech Stack</h1>
                            <hr />
                        </div>    
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <Col md={4} className="tech-col">
                        <Techcard name="Apache Spark" description="Apache Spark is an open-source, fast, distributed computing system for big data processing." link="https://spark.apache.org/" />
                    </Col>
                    <Col md={4} className="tech-col">
                        <Techcard name="Databricks" description="Databricks is a unified, cloud-based platform for building, deploying, and maintaining enterprise-grade data." link="https://www.databricks.com/" />
                    </Col>
                    <Col md={4} className="tech-col">
                        <Techcard name="Python" description="Python is a high-level, general-purpose programming language known for its extensive libraries." link="https://www.python.org/" />
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <Col md={4} className="tech-col">
                        <Techcard name="SQL" description="A standard language for managing relational databases and querying structured data." link="https://www.mysql.com/" />
                    </Col>
                    <Col md={4} className="tech-col">
                        <Techcard name="React" description="React lets you build user interfaces out of individual pieces called components." link="https://react.dev/" />
                    </Col>
                    <Col md={4} className="tech-col">
                        <Techcard name="Node.js" description="Node.js is an open source server environment. It allows you to run JavaScript on the server." link="https://nodejs.org/en" />
                    </Col>
                </Row>
                {expanded && 
                <Row className="justify-content-center">
                    <Col md={4} className="tech-col">
                        <Techcard name="Express.js" description="Express.js is a back end web application framework for building RESTful APIs with Node.js." link="https://expressjs.com/" />
                    </Col>
                    <Col md={4} className="tech-col">
                        <Techcard name="MongoDB" description="MongoDB is an open-source document database and leading NoSQL database." link="https://www.mongodb.com/" />
                    </Col>
                    <Col md={4} className="tech-col">
                        <Techcard name="EJS" description="EJS is a simple templating language that lets you generate HTML markup with plain JavaScript." link="https://ejs.co/" />
                    </Col>
                    <Col md={10} className="">
                        <Button className="expand-button mb-5" onClick={handleExpand}>Show Less
                            <FaAngleUp className="ms-1" />
                        </Button>
                    </Col>
                </Row>
                }
                {!expanded && 
                <Row className="justify-content-center">
                    <Col md={2}>
                        <Button className="expand-button mb-5" onClick={handleExpand}>Show More
                            <FaAngleDown className="ms-1" />
                        </Button>
                    </Col>
                </Row>
                }

            </Container>
        </section>
    );
}

export default Tech;